// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PageNotFound_info-container__lV9ef {
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/views/PageNotFound/PageNotFound.module.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAFF","sourcesContent":["@use 'styles/colors';\n@use 'styles/typography';\n\n.info-container {\n  height: 100px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info-container": `PageNotFound_info-container__lV9ef`
};
export default ___CSS_LOADER_EXPORT___;
